'use client';

import { SatelliteConversationReadRepliedStatusTypeV2 } from '@zg-rentals/ts-satellite-client';
import { useSatelliteWebLandlordConversationHandler_getLatestConversationsForInbox } from '@zg-rentals/ts-satellite-client-react-query';

import type {
  ListingAlias,
  SatelliteWebLandlordGetLatestConversationsForInboxRequestDto,
} from '@zg-rentals/ts-satellite-client';

export const LANDLORD_LATEST_CONVERSATIONS_TAG = 'landlord-latest-conversations';

// Re-exported so consumers can build the request without importing the raw
// satellite client themselves (Proxit).
export { SatelliteConversationReadRepliedStatusTypeV2 };
export type { ListingAlias, SatelliteWebLandlordGetLatestConversationsForInboxRequestDto };

type Options = NonNullable<
  Parameters<typeof useSatelliteWebLandlordConversationHandler_getLatestConversationsForInbox>[1]
>;

/**
 * Wraps the landlord latest-conversations query so consumers reach satellite
 * through this module rather than the raw client (Proxit).
 */
export function useLatestConversationsForInbox(
  postData: SatelliteWebLandlordGetLatestConversationsForInboxRequestDto,
  options?: Options,
) {
  return useSatelliteWebLandlordConversationHandler_getLatestConversationsForInbox(postData, {
    ...options,
    // Caller meta is spread first so the wrapper's tags/context always win.
    meta: {
      ...options?.meta,
      tags: [LANDLORD_LATEST_CONVERSATIONS_TAG],
      context: { api: 'satellite-api', details: 'getLatestConversationsForInbox' },
    },
  });
}
